<template>
<div class="chapter">
<div class="inner_page">
<p class="tx11">My grandmother was a novelist without knowing it. She knew nothing about how to become a novelist and, if she had, it would never have occurred to her as feasible. The alternative path she took is now well-known.</p>
<p class="tx">This is a collection of papers and memories: my grandmother’s diaries, an account of a crime and a transcript of a trial, letters and documents and the things I remember. It is a double detective story, a quest for an identity and a quest for a lost child. At the same time it is a voyage of discovery and a witness to the triumph of chance.</p>
<p class="tx">At first I thought I must include the diaries in their entirety. It was impossible; I would have had a volume of a million words. Besides, most of my readers, if the sales figures are anything to go by, will already have read <i>Asta.</i> It seems to me sometimes that the whole world has read it. You may possess Parts I to IV and have them on your shelves, at least in the paperback editions. You will know that the passages I include are extracts only and if you want to put them in context have simply to consult your own copies. I have been obliged to choose the relevant passages—relevant, that is, to Swanny’s story and to Edith’s.</p>
<p class="tx">As to those few who have only heard of the diaries, heard them read on audio cassettes or seen the television adaptations, I would remind them that the notebooks themselves span sixty-two years, that those from 1905 to 1944 have already filled four fat volumes and that there are more to come.</p>
<p class="btx">It is the fashion to make films about how a film was made and television documentaries about producing documentaries. This book is about discovering a diary and about the long arm, nearly a century long, of artfulness and well-intentioned deceit.</p>
<p class="txc"><i>Ann Eastbrook<br/>Hampstead<br/>1991</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded1.vue?a998c5f4